import { useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import {
    setAlert,
    setCreditCardForm,
    setSelectedPost,
    updatePost,
} from "../../../redux/actions";
import currency from "currency.js";
import RenderFees from "./render-fees";
import CountDownTimer from "../CountDownTimer";
import PriceText from "../PriceText";
import PaymentOptions from "../PaymentOptions";
import { TRANSACTION_TYPE } from "../../utils/constants";

const UnlockPurchaseButton = ({ posts, post, activePost }) => {
    const dispatch = useDispatch();

    const [ppvFees, setPpvFees] = useState("");
    const [confirming, setConfirming] = useState(false);
    const [processingPayment, setProcessingPayment] = useState(false);
    const [isDiscounted, setIsDiscounted] = useState(false);
    const [showPaymentOptions, setShowPaymentOptions] = useState(false);

    const showCcForm = () => {
        dispatch(
            setCreditCardForm({
                show: true,
                prefilled: true,
                closeOnly: true,
                intent: "PPV payment",
            })
        );
    };

    const handleUnlock = () => {
        setConfirming(true);
        axios
            .get(`/api/posts/fees`, {
                params: {
                    ppv_price: post.price,
                    post_id: post.id,
                },
            })
            .then((response) => {
                setConfirming(false);
                setPpvFees(response.data);
            });
    };

    const handlePayment = async () => {
        dispatch(setSelectedPost(post));
        setProcessingPayment(true);
        axios
            .post("/api/posts/pay", {
                post_id: post.id,
            })
            .then((response) => {
                dispatch(
                    setAlert({
                        show: true,
                        type: "success",
                        body: `Payment successful`,
                    })
                );

                dispatch(
                    updatePost({
                        posts: posts,
                        activePost: response.data.post,
                    })
                );

                setProcessingPayment(false);
                dispatch(setSelectedPost(response.data.post));
            })
            .catch((error) => {
                setProcessingPayment(false);
                console.error({ error });
                if (error.response) {
                    if (error.response.status === 503) {
                        dispatch(
                            setAlert({
                                show: true,
                                type: "error",
                                body:
                                    error.response.data.message ||
                                    'There is an error processing the payment, please contact support <a href="https://priva.uvdesk.com/en/" target="_blank">here</a>.',
                            })
                        );
                        return;
                    }

                    if (
                        error.response.data.message === CARD_ERRORS.NO_CARD &&
                        error.response.status === 402
                    ) {
                        showCcForm();
                    }

                    if (
                        error.response.status === 409 ||
                        (error.response.data.message !== CARD_ERRORS.NO_CARD &&
                            error.response.status === 402)
                    ) {
                        showCcForm();
                        dispatch(
                            setAlert({
                                show: true,
                                type: "error",
                                body: error.response.data.message,
                            })
                        );
                    }

                    if (
                        error.response.status > 400 &&
                        error.response.status < 500
                    ) {
                        showCcForm();
                    }
                } else {
                    dispatch(
                        setAlert({
                            show: true,
                            type: "error",
                            body: `Payment failed. Please contact support <a href="https://priva.uvdesk.com/en/">here</a>`,
                        })
                    );
                }

                setProcessingPayment(false);
                dispatch(setSelectedPost({}));
            });
    };

    const handleEndTime = () => {
        setIsDiscounted(false);
    };

    const handlePaymentOptions = () => {
        setShowPaymentOptions(!showPaymentOptions);
    };

    if (!ppvFees) {
        return (
            <div className="post__purchase">
                <button
                    className="btn-post-ppv"
                    onClick={handleUnlock}
                    disabled={confirming}
                >
                    UNLOCK POST FOR{" "}
                    <PriceText
                        price={post.price}
                        discountedPrice={post.promo_price}
                        isDiscounted
                    />
                </button>

                {isDiscounted ? (
                    <div
                        style={{
                            color: "#e3342f",
                            padding: "8px",
                            textAlign: "center",
                        }}
                    >
                        Limited offer expires in:&nbsp;&nbsp;
                        <CountDownTimer
                            dateTime={post.expire_at}
                            id={post.id}
                            onEndTime={handleEndTime}
                            isUTC
                        />
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }

    return (
        <div className="post__purchase">
            <button
                className="btn-post-ppv"
                onClick={handlePaymentOptions}
                disabled={processingPayment}
            >
                {processingPayment ? (
                    "Processing..."
                ) : (
                    <React.Fragment>
                        PAY{" "}
                        <PriceText
                            price={post.price}
                            discountedPrice={post.promo_price}
                            isDiscounted
                        />
                    </React.Fragment>
                )}
            </button>

            <RenderFees ppvFees={ppvFees} />

            {isDiscounted ? (
                <div
                    style={{
                        color: "#e3342f",
                        padding: "8px",
                        textAlign: "center",
                    }}
                >
                    Limited offer expires in:&nbsp;&nbsp;
                    <CountDownTimer
                        dateTime={post.expire_at}
                        id={post.id}
                        onEndTime={handleEndTime}
                        isUTC
                    />
                </div>
            ) : (
                ""
            )}
        </div>
    );
};

export default UnlockPurchaseButton;
